<template>
  <el-container class="chat-page">
    <resizable-aside :default-width="260" :min-width="200" :max-width="500" storage-key="chat-aside-width">
      <div class="aside-extra-btns" v-if="userStore.userInfo && userStore.userInfo.type == 1&& userStore.userInfo.isAdmin">
        <el-button type="primary" size="small" plain @click="onShowAddUserDialog">新增</el-button>
      </div>
      <div class="chat-extra-bar chat-extra-bar--in-aside" v-if="showInviteExtra">
        <div class="aside-extra-btns">
          <el-button v-if="userStore.userInfo.isButton" type="primary" size="small" plain
            @click="onGenerateInviteLink">新增链接</el-button>
          <el-button v-if="userStore.userInfo.isCode" type="primary" size="small" plain
            @click="onShowQrCode">二维码</el-button>
        </div>
       
        <div class="chat-welcome-row" v-if="userStore.userInfo.isButton">
          <el-input v-model="welcomeMessageDraft" size="small" clearable class="welcome-input"
            placeholder="请配置欢迎语，使用 # 分割多条欢迎语" />
          <el-button type="primary" size="small" @click="onSaveMessageData">保存</el-button>
        </div>
        <div class="chat-welcome-row" v-if="userStore.userInfo.isButton">
          <el-input v-model="nameTemplateDraft" size="small" clearable class="welcome-input"
            placeholder="请配置昵称模板（nameTemplate）" />
          <el-button type="primary" size="small" @click="onSaveMessageData">保存</el-button>
        </div>
      </div>
     
      <div class="header">
        <el-input class="search-text" size="small" placeholder="搜索聊天或消息记录" v-model="searchText">
          <i class="el-icon-search el-input__icon" slot="prefix"> </i>
        </el-input>
      </div>
      <div class="chat-loading" v-if="loading" v-loading="true" element-loading-text="消息接收中..."
        element-loading-spinner="el-icon-loading" element-loading-background="#F9F9F9" element-loading-size="24">
      </div>
      <el-scrollbar class="chat-items" v-else>
        <div v-for="(chat, index) in chatStore.chats" :key="index">
          <chat-item v-show="!chat.delete && chat.showName && isChatMatchSearch(chat)" :chat="chat"
            :index="index" @click.native="onActiveItem(index)" @delete="onDelItem(index)" @top="onTop(index)"
            @dnd="onDnd(chat)" :active="chat === chatStore.activeChat"></chat-item>
        </div>
      </el-scrollbar>
    </resizable-aside>
    <el-container class="chat-main-wrap" direction="vertical">
      <chat-box v-if="chatStore.activeChat" :chat="chatStore.activeChat"></chat-box>
      <el-dialog :visible.sync="qrDialogVisible" width="320px" append-to-body custom-class="qr-dialog-plain">
        <template slot="title">
          <div class="qr-dialog-title">
            <div class="qr-bg-toolbar">
              <el-button size="mini" type="primary" plain @click="onSelectQrBgImage">上传背景图片</el-button>
              <input
                ref="qrBgFileInput"
                class="qr-bg-file-input"
                type="file"
                accept="image/*"
                @change="onQrBgFileChange"
              />
            </div>
            <el-input
              v-model="qrTitle"
              size="small"
              maxlength="20"
              placeholder="请输入标题"
              class="qr-title-input"
            />
          </div>
        </template>
        <div
          class="qr-dialog-body"
          v-if="qrInviteSegment"
          :class="{ 'qr-dialog-body--dragging': qrBgDragging, 'qr-dialog-body--draggable': !!qrDialogBgImageUrl }"
          :style="{ backgroundColor: qrDialogBgImageUrl ? 'transparent' : '#f5f7fa' }"
          @mousedown="onQrBgDragStart"
        >
          <div
            v-if="qrDialogBgImageUrl"
            class="qr-bg-layer"
            :style="{
              backgroundImage: `url(${qrDialogBgImageUrl})`,
              transform: `scale(${qrBgScale})`
            }"
          ></div>
          <p class="qr-sub-title">{{ qrTitle || "二维码" }}</p>
          <img class="qr-img" :src="qrImageSrc" alt="二维码" />
          <p class="qr-tip">{{ qrInviteSegment }}</p>
        </div>
      </el-dialog>
      <el-dialog v-dialogDrag title="新增账号" :visible.sync="addUserDialogVisible" width="520px" append-to-body
        :close-on-click-modal="false" :close-on-press-escape="false" :before-close="onCloseAddUserDialog">
        <el-form :model="addUserForm" label-width="120px" :rules="addUserRules" ref="addUserFormRef" size="small">
          <el-form-item label="账号" prop="userName">
            <el-input v-model="addUserForm.userName" autocomplete="off" maxlength="20"
              placeholder="用于登录，最多20字符"></el-input>
          </el-form-item>
          <el-form-item label="昵称" prop="nickName">
            <el-input v-model="addUserForm.nickName" autocomplete="off" maxlength="20"
              placeholder="展示昵称，最多20字符"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <div class="password-row">
              <el-input
                v-model="addUserForm.password"
                autocomplete="off"
                maxlength="20"
                show-password
                placeholder="默认 123456"
              ></el-input>
              <div class="password-switch-wrap">
                <span class="password-switch-label">随机：</span>
                <el-switch
                  v-model="addUserRandomPassword"
                  @change="onToggleAddUserRandomPassword"
                />
              </div>
            </div>
          </el-form-item>
          <el-form-item v-if="adminNumber > 0" :label="`管理员(${adminNumber})`" prop="type">
            <el-radio-group v-model="addUserForm.type">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="3">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="friendGroups.length" label="分组">
            <el-select v-model="addUserForm.groupId" clearable placeholder="可不选" style="width: 100%">
              <el-option v-for="g in friendGroups" :key="g.id" :value="g.id" :label="g.name"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onCloseAddUserDialog()">取 消</el-button>
          <el-button type="primary" :loading="addUserSubmitting" @click="onSubmitAddUser()">确 定</el-button>
        </span>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue";
import ChatBox from "../components/chat/ChatBox.vue";
import ResizableAside from "../components/common/ResizableAside.vue";

export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
    ResizableAside
  },
  data() {
    return {
      searchText: "",
      messageContent: "",
      group: {},
      groupMembers: [],
      qrDialogVisible: false,
      qrInviteSegment: "",
      qrTitle: "二维码",
      qrDialogBgImageUrl: "",
      qrBgScale: 1,
      qrBgDragging: false,
      qrBgDragStartY: 0,
      qrBgScaleStart: 1,
      addUserDialogVisible: false,
      addUserSubmitting: false,
      addUserRandomPassword: false,
      friendGroups: [],
      addUserForm: {
        userName: "",
        nickName: "",
        password: "123456",
        type: 3,
        groupId: null
      },
      addUserRules: {
        userName: [{ required: true, message: "请输入账号", trigger: "blur" }],
        nickName: [{ required: true, message: "请输入昵称", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      welcomeMessageDraft: "",
      nameTemplateDraft: ""
    }
  },
  mounted() {
    this.syncWelcomeDraft();
  },
  beforeDestroy() {
    this.removeQrBgDragListeners();
    if (this.qrDialogBgImageUrl && this.qrDialogBgImageUrl.indexOf("blob:") === 0) {
      URL.revokeObjectURL(this.qrDialogBgImageUrl);
    }
  },
  activated() {
    this.syncWelcomeDraft();
  },
  watch: {
    userWelcomeSyncKey: {
      handler() {
        this.syncWelcomeDraft();
      },
      immediate: true
    }
  },
  methods: {
    loadFriendGroups() {
      this.$http({
        url: "/friendGroup/list",
        method: "get"
      }).then((list) => {
        this.friendGroups = Array.isArray(list) ? list : [];
        if (!this.friendGroups.length) {
          this.addUserForm.groupId = null;
        }
      }).catch(() => {});
    },
    syncWelcomeDraft() {
      const u = this.userStore.userInfo;
      if (!u || !u.id) {
        this.welcomeMessageDraft = "";
        this.nameTemplateDraft = "";
        return;
      }
      const m =
        u.messageData != null && u.messageData !== undefined
          ? u.messageData
          : u.message_data != null && u.message_data !== undefined
            ? u.message_data
            : "";
      this.welcomeMessageDraft = String(m);

      const nt =
        u.nameTemplate != null && u.nameTemplate !== undefined
          ? u.nameTemplate
          : u.name_template != null && u.name_template !== undefined
            ? u.name_template
            : "";
      this.nameTemplateDraft = String(nt);
    },
    onSaveMessageData() {
      const uid = this.userStore.userInfo && this.userStore.userInfo.id;
      if (!uid) {
        this.$message.warning("请先登录");
        return;
      }
      this.$http({
        url: "/user/messageData",
        method: "PUT",
        data: {
          userId: uid,
          messageData: this.welcomeMessageDraft,
          nameTemplate: this.nameTemplateDraft
        }
      }).then(() => {
        this.$message.success("保存成功");
        this.userStore.loadUser().then(() => {
          this.syncWelcomeDraft();
        });
      });
    },
    normalizeInvitePayload(data) {
      if (data == null) {
        return "";
      }
      if (typeof data === "string") {
        return data.trim();
      }
      if (typeof data === "object") {
        if (data.link != null && String(data.link).trim()) {
          return String(data.link).trim();
        }
        if (data.data != null) {
          return this.normalizeInvitePayload(data.data);
        }
        if (data.message != null) {
          const m = String(data.message).trim();
          if (m && m !== "成功") {
            return m;
          }
        }
      }
      const s = String(data).trim();
      return s === "[object Object]" ? "" : s;
    },
    copyTextRobust(text) {
      const str = text == null ? "" : String(text);
      if (!str) {
        return Promise.resolve(false);
      }
      const fallbackCopy = () => {
        try {
          const ta = document.createElement("textarea");
          ta.value = str;
          ta.setAttribute("readonly", "readonly");
          ta.style.cssText = "position:fixed;left:-9999px;top:0;opacity:0;";
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          ta.setSelectionRange(0, str.length);
          const ok = document.execCommand("copy");
          document.body.removeChild(ta);
          return ok;
        } catch (e) {
          return false;
        }
      };
      if (navigator.clipboard && window.isSecureContext && typeof navigator.clipboard.writeText === "function") {
        return navigator.clipboard.writeText(str).then(() => true).catch(() => fallbackCopy());
      }
      return Promise.resolve(fallbackCopy());
    },
    async onGenerateInviteLink() {
      try {
        const raw = await this.$http({
          url: "/user/generateInviteLink",
          method: "POST"
        });
        const segment = this.normalizeInvitePayload(raw).trim();
        if (!segment) {
          this.$message.warning("未获取到邀请链接，请检查用户是否已配置 domain");
          return;
        }
        const ok = await this.copyTextRobust(segment);
        if (ok) {
          this.$message.success("复制成功");
        } else {
          this.$message.error("复制失败，请手动复制：" + segment);
        }
        this.userStore.loadUser();
      } catch (e) {
        // 错误已由 http 拦截器提示
      }
    },
    async onShowQrCode() {
      try {
        const raw = await this.$http({
          url: "/user/generateInviteLink",
          method: "POST"
        });
        const segment = this.normalizeInvitePayload(raw).trim();
        if (!segment) {
          this.$message.warning("未获取到邀请链接，请检查用户是否已配置 domain");
          return;
        }
        const ok = await this.copyTextRobust(segment);
        if (ok) {
          this.$message.success("复制成功");
        } else {
          this.$message.error("复制失败，请手动复制下方内容");
        }
        this.qrInviteSegment = segment;
        this.qrDialogVisible = true;
        this.userStore.loadUser();
      } catch (e) {
        // 错误已由 http 拦截器提示
      }
    },
    onSelectQrBgImage() {
      if (this.$refs.qrBgFileInput) {
        this.$refs.qrBgFileInput.click();
      }
    },
    onQrBgFileChange(e) {
      const files = e && e.target && e.target.files ? e.target.files : null;
      const file = files && files.length ? files[0] : null;
      if (!file) {
        return;
      }
      if (!file.type || file.type.indexOf("image/") !== 0) {
        this.$message.warning("请上传图片文件");
        e.target.value = "";
        return;
      }
      if (this.qrDialogBgImageUrl && this.qrDialogBgImageUrl.indexOf("blob:") === 0) {
        URL.revokeObjectURL(this.qrDialogBgImageUrl);
      }
      const reader = new FileReader();
      reader.onload = () => {
        this.qrDialogBgImageUrl = typeof reader.result === "string" ? reader.result : "";
        this.qrBgScale = 1;
        if (!this.qrDialogBgImageUrl) {
          this.$message.warning("图片读取失败，请重试");
          return;
        }
        this.$message.success("背景图已更新，可在图片区域上下拖动缩放");
      };
      reader.onerror = () => {
        this.$message.warning("图片读取失败，请重试");
      };
      reader.readAsDataURL(file);
      e.target.value = "";
    },
    onQrBgDragStart(e) {
      if (!this.qrDialogBgImageUrl || !e || e.button !== 0) {
        return;
      }
      this.qrBgDragging = true;
      this.qrBgDragStartY = e.clientY;
      this.qrBgScaleStart = this.qrBgScale;
      this.bindQrBgDragListeners();
      e.preventDefault();
    },
    onQrBgDragMove(e) {
      if (!this.qrBgDragging) {
        return;
      }
      const deltaY = this.qrBgDragStartY - e.clientY;
      const nextScale = this.qrBgScaleStart + deltaY * 0.005;
      this.qrBgScale = Math.min(2.5, Math.max(0.5, Number(nextScale.toFixed(2))));
    },
    onQrBgDragEnd() {
      if (!this.qrBgDragging) {
        return;
      }
      this.qrBgDragging = false;
      this.removeQrBgDragListeners();
    },
    bindQrBgDragListeners() {
      window.addEventListener("mousemove", this.onQrBgDragMove);
      window.addEventListener("mouseup", this.onQrBgDragEnd);
      window.addEventListener("mouseleave", this.onQrBgDragEnd);
    },
    removeQrBgDragListeners() {
      window.removeEventListener("mousemove", this.onQrBgDragMove);
      window.removeEventListener("mouseup", this.onQrBgDragEnd);
      window.removeEventListener("mouseleave", this.onQrBgDragEnd);
    },
    buildNewUserCopyText(tenantMobileDomain, userName, password) {
      const account = userName == null ? "" : String(userName);
      const pwd = password == null ? "" : String(password);
      const domain = tenantMobileDomain == null ? "" : String(tenantMobileDomain).trim();
      if (domain) {
        return `网站是：${domain}  账号是：${account}  密码是：${pwd}`;
      }
      return `账号是：${account}  密码是：${pwd}`;
    },
    generateRandomSixDigitPassword() {
      return String(Math.floor(100000 + Math.random() * 900000));
    },
    async onToggleAddUserRandomPassword(enabled) {
      const prev = !enabled;
      try {
        await this.$http({
          url: "/user/passwordSwitch",
          method: "PUT",
          data: { isPassword: !!enabled }
        });
        await this.userStore.loadUser();
        if (enabled) {
          this.addUserForm.password = this.generateRandomSixDigitPassword();
        }
      } catch (e) {
        this.addUserRandomPassword = prev;
      }
    },
    getUserRandomPasswordSwitch() {
      const u = this.userStore.userInfo || {};
      if (u.isPassword != null) {
        return !!u.isPassword;
      }
      if (u.is_password != null) {
        return !!u.is_password;
      }
      return false;
    },
    onShowAddUserDialog() {
      this.addUserRandomPassword = this.getUserRandomPasswordSwitch();
      if (this.addUserRandomPassword) {
        this.addUserForm.password = this.generateRandomSixDigitPassword();
      }
      this.addUserDialogVisible = true;
      this.loadFriendGroups();
      this.$nextTick(() => {
        if (this.$refs.addUserFormRef) {
          this.$refs.addUserFormRef.clearValidate();
        }
      });
    },
    onCloseAddUserDialog() {
      this.addUserDialogVisible = false;
      this.addUserSubmitting = false;
      this.addUserRandomPassword = false;
      this.addUserForm = {
        userName: "",
        nickName: "",
        password: "123456",
        type: 3,
        groupId: null
      };
    },
    onSubmitAddUser() {
      if (this.addUserSubmitting) {
        return;
      }
      this.$refs.addUserFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        const u = this.userStore.userInfo;
        const tenantId =
          u && (u.tenantId != null && u.tenantId !== undefined ? u.tenantId : u.id);
        if (tenantId == null) {
          this.$message.warning("无法获取租户信息，请重新登录");
          return;
        }
        this.addUserSubmitting = true;
        try {
          const created = await this.$http({
            url: "/user/registerType3",
            method: "POST",
            data: {
              ...this.addUserForm,
              operatorId: u && u.id,
              tenantId
            }
          });
          if (created && created.id && this.addUserForm.groupId != null) {
            try {
              await this.$http({
                url: "/friendGroup/assign",
                method: "put",
                data: { friendId: created.id, groupId: this.addUserForm.groupId }
              });
              const g = this.friendGroups.find(x => x.id === this.addUserForm.groupId);
              this.friendStore.updateFriend({
                id: created.id,
                groupId: this.addUserForm.groupId,
                groupName: g ? g.name : undefined
              });
            } catch (e) {
              // 分组失败不影响新增账号主流程
            }
          }
          const account = this.addUserForm.userName;
          const password = this.addUserForm.password;
          const domain =
            u && (u.tenantMobileDomain != null && u.tenantMobileDomain !== undefined
              ? u.tenantMobileDomain
              : u.tenant_mobile_domain);
          const copyText = this.buildNewUserCopyText(domain, account, password);
          const copied = await this.copyTextRobust(copyText);
          if (copied) {
            this.$message.success("新增账号成功，账号信息已复制");
          } else {
            this.$message.success("新增账号成功");
            this.$message.warning("复制失败，请手动复制：" + copyText);
          }
          this.onCloseAddUserDialog();
        } catch (e) {
          // 错误由 http 拦截器提示
        } finally {
          this.addUserSubmitting = false;
        }
      });
    },
    onActiveItem(index) {
      this.chatStore.setActiveChat(index);
    },
    onDelItem(index) {
      this.chatStore.removeChat(index);
    },
    onTop(chatIdx) {
      this.chatStore.moveTop(chatIdx);
    },
    onDnd(chat) {
      if (chat.type == 'PRIVATE') {
        this.setFriendDnd(chat, chat.targetId, !chat.isDnd)
      } else {
        this.setGroupDnd(chat, chat.targetId, !chat.isDnd)
      }
    },
    isChatMatchSearch(chat) {
      if (!this.searchText || !this.searchText.trim()) {
        return true;
      }

      const keyword = this.searchText.trim().toLowerCase();

      if (chat.showName && chat.showName.toLowerCase().includes(keyword)) {
        return true;
      }

      if (chat.lastContent && chat.lastContent.toLowerCase().includes(keyword)) {
        return true;
      }

      if (chat.messages && Array.isArray(chat.messages) && chat.messages.length > 0) {
        const maxSearchCount = 50;
        const startIdx = Math.max(0, chat.messages.length - maxSearchCount);

        for (let i = chat.messages.length - 1; i >= startIdx; i--) {
          const msg = chat.messages[i];
          if (msg && msg.type === this.$enums.MESSAGE_TYPE.TEXT && msg.content) {
            if (msg.content.toLowerCase().includes(keyword)) {
              return true;
            }
          }
        }
      }

      return false;
    },
    setFriendDnd(chat, friendId, isDnd) {
      let formData = {
        friendId: friendId,
        isDnd: isDnd
      }
      this.$http({
        url: '/friend/dnd',
        method: 'put',
        data: formData
      }).then(() => {
        this.friendStore.setDnd(friendId, isDnd)
        this.chatStore.setDnd(chat, isDnd)
      })
    },
    setGroupDnd(chat, groupId, isDnd) {
      let formData = {
        groupId: groupId,
        isDnd: isDnd
      }
      this.$http({
        url: '/group/dnd',
        method: 'put',
        data: formData
      }).then(() => {
        this.groupStore.setDnd(groupId, isDnd)
        this.chatStore.setDnd(chat, isDnd)
      })
    }
  },
  computed: {
    adminNumber() {
      const u = this.userStore.userInfo;
      return u && u.adminNumber != null ? u.adminNumber : 0;
    },
    loading() {
      return this.chatStore.loading;
    },
    showInviteExtra() {
      const u = this.userStore.userInfo;
      return u && (u.isButton === true || u.isCode === true);
    },
    userWelcomeSyncKey() {
      const u = this.userStore.userInfo;
      if (!u || !u.id) {
        return null;
      }
      const md = u.messageData != null && u.messageData !== undefined ? u.messageData : u.message_data;
      const nt = u.nameTemplate != null && u.nameTemplate !== undefined ? u.nameTemplate : u.name_template;
      return `${u.id}\0${md === null || md === undefined ? "" : md}\0${nt === null || nt === undefined ? "" : nt}`;
    },
    qrImageSrc() {
      if (!this.qrInviteSegment) {
        return "";
      }
      return (
        "https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=" +
        encodeURIComponent(this.qrInviteSegment)
      );
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-page {
  ::v-deep .qr-dialog-plain {
    border: none;
    box-shadow: none;
  }

  .chat-main-wrap {
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }

  .chat-extra-bar {
    flex-shrink: 0;
    padding: 8px 12px;
    border-top: 1px solid var(--im-border, #ebeef5);
    background: #fafafa;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  .chat-extra-bar--in-aside {
    border-top: none;
    border-bottom: 1px solid var(--im-border, #ebeef5);
    flex-direction: column;
    align-items: stretch;
    padding: 8px;

    .aside-extra-btns {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }

    .chat-welcome-row {
      flex-direction: column;
      align-items: stretch;
      min-width: 0;
      max-width: none;
      margin-left: 0;
      margin-top: 8px;
    }

    .welcome-input {
      width: 100%;
      min-width: 0;
    }
  }

  .chat-welcome-row {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 260px;
    max-width: 560px;
    gap: 8px;
    margin-left: 4px;
  }

  .welcome-input {
    flex: 1;
    min-width: 180px;
  }

  .password-row {
    display: flex;
    align-items: center;
    gap: 10px;

    .el-input {
      flex: 1;
    }

    .password-switch-wrap {
      width: 120px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-shrink: 0;
    }

    .password-switch-label {
      color: #606266;
      font-size: 13px;
      white-space: nowrap;
      height: 32px;
      line-height: 32px;
      display: inline-block;
    }
  }

  .qr-dialog-body {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 260px;
    gap: 12px;
    text-align: center;
    padding: 12px;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;

    &.qr-dialog-body--draggable {
      cursor: ns-resize;
      user-select: none;
    }

    &.qr-dialog-body--dragging {
      cursor: ns-resize;
    }

    .qr-bg-layer {
      position: absolute;
      inset: 0;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      transform-origin: center center;
      z-index: 0;
    }

    .qr-img {
      display: block;
      margin: 0 auto;
      position: relative;
      z-index: 1;
    }

    .qr-sub-title {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      line-height: 1.3;
      color: #303133;
      text-align: center;
      word-break: break-word;
      position: relative;
      z-index: 1;
    }

    .qr-tip {
      position: relative;
      z-index: 1;
      margin: 0;
      padding: 0 6px;
      background: rgba(255, 255, 255, 0.65);
      border-radius: 4px;
    }

    .qr-stage {
      position: relative;
      width: 160px;
      height: 160px;
      margin: 0 auto;
      border-radius: 10px;
      overflow: hidden;
      background: #f5f6f8;
      box-shadow: 0 10px 24px rgba(0, 0, 0, 0.10);

      .qr-bg {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }

      .qr-img {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 100px;
        height: 100px;
        transform: translate(-50%, -50%);
        border-radius: 8px;
        background: #fff;
        box-shadow: 0 8px 18px rgba(0, 0, 0, 0.12);
      }
    }

    .qr-actions {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }

  .qr-dialog-title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-right: 28px; // 预留右侧关闭按钮空间，保持视觉居中
    box-sizing: border-box;
    gap: 8px;

    .qr-bg-toolbar {
      width: 100%;
      display: flex;
      justify-content: center;
    }

    .qr-bg-file-input {
      display: none;
    }

    .qr-title-input {
      width: 180px;
      max-width: 100%;
    }

    ::v-deep .el-input__inner {
      text-align: center;
      font-weight: 600;
      border: none;
      box-shadow: none;
      background: transparent;
      padding-left: 0;
      padding-right: 0;
    }

    ::v-deep .el-input__inner:hover,
    ::v-deep .el-input__inner:focus {
      border: none;
      box-shadow: none;
    }
  }

  .header {
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 8px;
  }

  .chat-loading {
    height: 50px;
    background-color: #eee;

    .el-icon-loading {
      font-size: 24px;
      color: var(--im-text-color-light);
    }

    .el-loading-text {
      color: var(--im-text-color-light);
    }
  }

  .chat-items {
    flex: 1;
  }

}
</style>
